const MenuResources = (dropdownTwoRef, closeDropdownMenu) => {
  return (
    <ul ref={dropdownTwoRef}>
      <li className="px-4 py-2 hover:bg-containx-beige">
        <a
          href="/pdf/product-catalog.pdf"
          target="_blank"
          rel="noopener noreferrer"
          onClick={closeDropdownMenu}
          className="block"
        >
          Product Catalog
        </a>
      </li>
    </ul>
  );
};

export default MenuResources;
